import { logger } from "../services/logger";
import { BetSlipUpdatePayload, Handler } from "../common/types";
import { IframeActions } from "../common/events";
import { WIDGET_METADATA } from "../common/config";

const getUniqueSelectionIds = (payload: BetSlipUpdatePayload): Array<{ selectionId: string }> => {
  return Object.keys(payload).map((id) => ({ selectionId: `OB_OU${id}` }));
};

export const betSlipUpdate: Handler<BetSlipUpdatePayload> = (payload, { stateMngr, iframe }) => {
  logger.log(`[From MsgBus]: On betslip update: `, payload);

  const widgetType = iframe.getWidgetType();
  const metadata = WIDGET_METADATA[widgetType];

  if (!metadata.requiresGtpMapping) {
    const selections = getUniqueSelectionIds(payload);
    iframe.publish(IframeActions.UPDATE_BETSLIP_ACCA, { selections });
    logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP_ACCA}: `, { selections });
    return;
  }

  const response = stateMngr.handleOnBetslipUpdate(payload);
  iframe.publish(IframeActions.UPDATE_BETSLIP, response);
  logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP}: `, response);
};
